module.exports = __webpack_public_path__ + "static/media/invoices.3f7f9ffb.png";